import { pluralize } from '~/lib/str/mod.js';

const convertArg = arg => {
	const num = Number(arg);
	return Number.isFinite(num) ? Math.max(num, 0) : 0;
};

const timeUnits = [
	[1000, 'second((s))'],
	[60, 'minute((s))'],
	[60, 'hour((s))'],
];

/**
 * Convert a number of milliseconds to a human readable duration string
 *
 * @param {number} [milliseconds=0] The number if milliseconds to convert
 * @returns {string} The human readable duration of time
 *
 * @note {@link milliseconds} is numerified before use
 */
export const duration = (milliseconds = 0) => {
	const m = convertArg(milliseconds);
	if (m === 0) {
		return '0 seconds';
	}

	const [time, label] = timeUnits.reduce(
		(acc, [unit, label]) => {
			const [currTime, , cont] = acc;
			if (cont && currTime >= unit) {
				// Time can be reduced again
				acc[0] = currTime / unit;
				acc[1] = label;
			} else {
				// Time is reduced as must as possible
				acc[2] = false;
			}

			return acc;
		},
		[m, 'millisecond((s))', true]
	);

	return `${time} ${pluralize(time, label)}`;
};
